import styled, { css } from "styled-components";
import { Flex } from "../Flex";
import { blueScrollBarStyles, getPropertyByMedia, getThemeMedia, getThemeSpace } from "../helpers";
import { getTableVariantStyle } from "./helpers";
const heightHeader = "52px";
export const Container = styled.div `
	position: relative;

	border-radius: 8px;
	border: 1px solid var(--border-primary);
	background-color: var(--surface-white);

	width: 100%;

	overflow: hidden;

	${({ variant }) => variant === "simple" &&
    css `
			border: 1px solid var(--mine-shaft200);
		`};

	${({ size }) => size === "small" &&
    css `
			border-radius: 4px;
		`};

	${({ preventCardAdaptation }) => !preventCardAdaptation &&
    css `
			@media screen {
				@media (max-width: ${getThemeMedia("medium")}) {
					overflow-x: hidden;
					border: none;
					border-radius: 0;
					margin: 0 -16px;
					width: calc(100% + 32px);
				}
			}
		`}

	[data-row-wrapper="true"] {
		&:nth-child(odd) {
			background-color: var(--surface-primary);

			[role="cell"]:last-child {
				background-color: var(--surface-primary);
			}
		}

		${({ whiteSpaceRow }) => whiteSpaceRow && css `
			@media screen {
				@media (max-width: ${getThemeMedia('medium')}) {
					padding: 8px 0;
				}
			}
		`}
	}

	& > * {
		${blueScrollBarStyles()}
	}

`;
const Grid = styled.div `
	position: relative;
	display: grid;
	${({ templateColumns }) => getPropertyByMedia("grid-template-columns", templateColumns, "auto")}
	align-items: center;
	gap: 8px;

	padding-left: ${getThemeSpace("8")};

	width: min-content;


	@media screen {
		@media (min-width: ${getThemeMedia('medium')}) {
			padding-left: ${getThemeSpace("24")};
		}
	}

	${({ variant }) => variant !== "simple" && getTableVariantStyle(variant)}

	${({ size }) => size === "small" &&
    css `
			max-height: 36px;
	`}
`;
export const Header = styled(Grid) `
	height: 48px;
	border-bottom: 1px solid var(--border-primary);
	align-items: center;
	white-space: nowrap;

	@media screen {
		@media (min-width: ${getThemeMedia('medium')}) {
			height: ${heightHeader};
		}
	}

	${({ enableScroll }) => enableScroll &&
    css `
			overflow-x: auto;
			width: 100%;
		`};

	${({ variant }) => variant === "simple" &&
    css `
			width: 100%;
			background-color: var(--surface-primary);
			padding-left: ${getThemeSpace("16")};

			[role='cell'] {
				&:last-child {
					background-color: var(--surface-primary) !important;
					justify-content: flex-start;
				}
			}
		`};

	${({ preventCardAdaptation }) => !preventCardAdaptation
    ? css `
			@media screen {
				@media (max-width: ${getThemeMedia("medium")}) {
					display: none;
				}
			}
		`
    : css `
			@media screen {
				@media (max-width: ${getThemeMedia("medium")}) {
					[role='cell'] {
						justify-content: center;
					}
				}
			}
		`}

	[role="cell"]:not([data-col-name]) {
		display: none;
	}

	${({ disabled }) => disabled &&
    css `
			p {
				color: var(--text-disable);
			}
		`}
`;
export const Row = styled(Grid) `
	min-height: 56px;
	white-space: nowrap;

	${({ whiteSpaceRow = "nowrap" }) => getPropertyByMedia("white-space", whiteSpaceRow)}

	${({ notice }) => notice &&
    css `
			display: flex;
			justify-content: center;

			padding: 0;

			width: 100%;
			min-height: calc(${heightHeader} * 4);
		`}

	${({ variant }) => variant === "simple" &&
    css `
			--background-table-body: var(--surface-white);

			width: 100%;
			background-color: var(--background-table-body);
			padding-left: ${getThemeSpace("16")};

			&:nth-child(even),
			&:nth-child(even) [role='cell']:last-child,
			[role='cell']:last-child {
				background-color: var(--background-table-body) !important;
				justify-content: flex-start;
			}
		`};

	${({ size }) => size === "small" &&
    css `
			height: 36px;
		`};

	${({ preventCardAdaptation }) => !preventCardAdaptation &&
    css `
			@media screen {
				@media (max-width: ${getThemeMedia("medium")}) {
					grid-template-columns: 1fr;
					gap: 8px;

					padding: 24px;

					height: fit-content;
					width: 100%;

					background-color: var(--surface-primary);

					&:nth-child(even) {
						background-color: var(--surface-white);

						& [role='cell']:last-child {
							background-color: inherit !important;
						}
					}

					& [role='cell']:last-child {
						background-color: inherit !important;
					}
				}
			}
		`}
`;
export const Cell = styled(Flex) `
	height: 100%;
	align-items: center;
	gap: 0;

	span {
		text-overflow: ellipsis;
		overflow: hidden;
		max-width: 100%;
	}

	${({ emptyTable, disableFloatingColumn }) => !emptyTable && !disableFloatingColumn &&
    css `
			&:last-child {
				justify-content: end;
				position: sticky;
				right: 0;
				gap: 0;

				padding: 0 0 0 ${getThemeSpace("8")};

				background-color: var(--surface-white);
				box-shadow: 0px 3px 6px var(--neutral-black-10);

				@media screen {
					@media (min-width: ${getThemeMedia("large")}) {
						box-shadow: none;
					}
				}
			}
		`};

	${({ preventCardAdaptation }) => !preventCardAdaptation &&
    css `
			@media screen {
				@media (max-width: ${getThemeMedia("medium")}) {
					flex-direction: column;

					align-items: flex-start;

					&:last-child {
						position: relative;

						padding: 0;

						box-shadow: none;
					}
				}
			}
		`}
`;
//# sourceMappingURL=styles.js.map